document.addEventListener('DOMContentLoaded', function() {
  initHeader();
  initNavbarPredictiveSearch();
  initSearchPlaceholder();
  initLikeButtons();

  initScrollHandlers();
  initChallengePage();
  initNewsletter();
  initMobileMenu();
  initMobileDropdown();
  initFooterAccordion();
  initBottomBar();
  initCategoriesSlider();
  initFacetClickOutside();
  initSortPlaceholder();
  initViewToggle();
  initMetafieldToggles();
  initLoadMore();
  initPriceSliders();
  initPriceSliderObservers();
});

// Load More — delegated handler so it works after Dawn AJAX replaces #ProductGridContainer
function initLoadMore() {
  document.addEventListener('click', function(event) {
    var btn = event.target.closest('#loadMoreBtn');
    if (!btn) return;
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) { btn.style.display = 'none'; return; }
    btn.disabled = true;
    btn.textContent = 'Loading...';
    ['ProductCount', 'ProductCountDesktop'].forEach(function(id) { var el = document.getElementById(id); if (el) el.classList.add('loading'); });
    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('#product-grid .grid__item');
        var grid = document.getElementById('product-grid');
        if (grid && newItems.length) {
          newItems.forEach(function(item) { grid.appendChild(item.cloneNode(true)); });
          if (window._initCollectionCards) window._initCollectionCards();
        }
        var newBtn = doc.getElementById('loadMoreBtn');
        if (newBtn && newBtn.getAttribute('data-next-url')) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.disabled = false;
          btn.textContent = 'Load More';
        } else {
          btn.style.display = 'none';
        }
        ['ProductCount', 'ProductCountDesktop'].forEach(function(id) { var el = document.getElementById(id); if (el) el.classList.remove('loading'); });
        updateLoadedCount();
        autoLoadIfNeeded();
      })
      .catch(function() {
        ['ProductCount', 'ProductCountDesktop'].forEach(function(id) { var el = document.getElementById(id); if (el) el.classList.remove('loading'); });
        btn.disabled = false;
        btn.textContent = 'Load More';
      });
  });
  setTimeout(function() { updateLoadedCount(); autoLoadIfNeeded(); }, 100);
}

function autoLoadIfNeeded() {
  var grid = document.getElementById('product-grid');
  var btn = document.getElementById('loadMoreBtn');
  if (!grid || !btn || btn.disabled || btn.style.display === 'none') return;
  var ppp = parseInt(grid.getAttribute('data-ppp') || '0', 10);
  if (ppp > 0 && grid.querySelectorAll('.grid__item').length < ppp) {
    btn.click();
  }
}

function updateLoadedCount() {
  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var loaded = grid.querySelectorAll('.grid__item').length;
  ['ProductCount', 'ProductCountDesktop'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el || el.getAttribute('data-total') == null) return;
    var total = parseInt(el.getAttribute('data-total'), 10);
    if (!total) return;
    el.textContent = loaded + ' of ' + total + ' products';
  });
}

// Close facet dropdowns when clicking outside
function initFacetClickOutside() {
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.facets__disclosure[open]').forEach(function(details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });
}

// Show "Sort by" placeholder when no sort is selected
function initSortPlaceholder() {
  var select = document.getElementById('SortBy');
  if (!select) return;
  var hasSort = new URLSearchParams(window.location.search).has('sort_by');
  if (!hasSort) {
    // Liquid рендерит option[value=""] когда sort не выбран — просто убеждаемся что он выбран
    var placeholder = select.querySelector('option[value=""]');
    if (placeholder) {
      placeholder.selected = true;
    }
  }
}

// Grid / list view toggle — uses event delegation so it survives AJAX DOM changes
var _currentView = 'grid';

function initViewToggle() {
  // Event delegation on document for buttons that may be re-rendered
  document.addEventListener('click', function(event) {
    var btn = event.target.closest('.view-toggle__btn');
    if (!btn) return;
    _currentView = btn.dataset.view;
    document.querySelectorAll('.view-toggle__btn').forEach(function(b) { b.classList.remove('is-active'); });
    document.querySelectorAll('.view-toggle__btn[data-view="' + _currentView + '"]').forEach(function(b) { b.classList.add('is-active'); });
    applyViewMode(_currentView);
  });
}

function applyViewMode(view) {
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;
  container.classList.toggle('view--list', view === 'list');
  container.classList.toggle('view--grid', view === 'grid');
}

// Set --site-header-height so the mobile filter popup can sit below the header.
function syncHeaderHeight() {
  var h = document.querySelector('header.section-header, .shopify-section-header, sticky-header, .header-wrapper');
  if (!h) return;
  // На десктопе шапка липнет с отрицательным top (чёрная полоса уезжает за экран),
  // поэтому видимая высота прилипшей шапки = offsetHeight + top.
  var top = parseFloat(getComputedStyle(h).top) || 0;
  document.documentElement.style.setProperty('--site-header-height', (h.offsetHeight + Math.min(top, 0)) + 'px');
}
syncHeaderHeight();
window.addEventListener('resize', syncHeaderHeight);
window.addEventListener('load', syncHeaderHeight);

// Mobile filter popup: only one category open at a time.
// Event delegation on document so it survives AJAX rerenders.
document.addEventListener('toggle', function (event) {
  var d = event.target;
  if (!d || d.tagName !== 'DETAILS') return;
  if (!d.open) return;
  var wrap = d.closest('#FacetsWrapperMobile');
  if (!wrap) return;
  wrap.querySelectorAll('details[open]').forEach(function (other) {
    if (other !== d && !other.contains(d) && !d.contains(other)) {
      other.removeAttribute('open');
      other.classList.remove('menu-opening');
    }
  });
}, true);

// ===== Metafield toggles (Prescription Ready / Photochromic) =====
// Toggle buttons mirror metafield filters configured in Search & Discovery.
// They drive the same server-side FacetFiltersForm.renderPage flow as checkboxes,
// so activating a toggle returns a full paginated page (15 products by default),
// not just the subset of the currently loaded page.
var TOGGLE_SELECTOR = '#prescription-ready-toggle, #photochromic-toggle, #prescription-ready-toggle-mobile, #photochromic-toggle-mobile';

function syncMetafieldToggles() {
  var urlParams = new URLSearchParams(window.location.search);
  document.querySelectorAll(TOGGLE_SELECTOR).forEach(function(btn) {
    var name = btn.dataset.filterName;
    var value = btn.dataset.filterValue;
    if (!name || !value) return;
    var active = urlParams.getAll(name).indexOf(value) !== -1;
    btn.setAttribute('aria-checked', active ? 'true' : 'false');
  });
}

function initMetafieldToggles() {
  syncMetafieldToggles();
  window.addEventListener('pageshow', syncMetafieldToggles);
  window.addEventListener('popstate', syncMetafieldToggles);

  document.addEventListener('click', function(event) {
    var btn = event.target.closest(TOGGLE_SELECTOR);
    if (!btn) return;
    var filterName = btn.dataset.filterName;
    var filterValue = btn.dataset.filterValue;
    if (!filterName || !filterValue) return;

    var nextActive = btn.getAttribute('aria-checked') !== 'true';
    btn.setAttribute('aria-checked', nextActive ? 'true' : 'false');

    if (typeof FacetFiltersForm === 'undefined') return;

    FacetFiltersForm.filterData = [];

    // URL is the source of truth for active filters. FormData would miss the
    // other toggle's filter (we skip these from the checkbox list), so
    // clicking one toggle would strip the other from the resulting request.
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('page');

    var existing = urlParams.getAll(filterName);
    urlParams.delete(filterName);
    existing.forEach(function(v) { if (v !== filterValue) urlParams.append(filterName, v); });
    if (nextActive) urlParams.append(filterName, filterValue);

    FacetFiltersForm.renderPage(urlParams.toString());
  });

  // Dawn replaces #ProductGridContainer's innerHTML on filter/sort AJAX but leaves
  // the container element itself in the DOM — observer never needs to re-attach.
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    new MutationObserver(function() {
      syncMetafieldToggles();
      applyViewMode(_currentView);
      if (window._initCollectionCards) window._initCollectionCards();
      initPriceSliders();
    }).observe(gridContainer, { childList: true, subtree: false });
  }
}

// ── Price Range Slider ────────────────────────────────────────────────────────
// updateSliderFill: recomputes the highlighted fill div between the two handles
function updateSliderFill(slider) {
  var minRange = slider.querySelector('.price-slider__range--min');
  var maxRange = slider.querySelector('.price-slider__range--max');
  var fill = slider.querySelector('.price-slider__fill');
  if (!minRange || !maxRange || !fill) return;
  var min = parseFloat(minRange.min) || 0;
  var max = parseFloat(minRange.max) || 100;
  var minVal = parseFloat(minRange.value);
  var maxVal = parseFloat(maxRange.value);
  if (isNaN(minVal)) minVal = min;
  if (isNaN(maxVal)) maxVal = max;
  var minPct = ((minVal - min) / (max - min)) * 100;
  var maxPct = ((maxVal - min) / (max - min)) * 100;
  fill.style.left = minPct + '%';
  fill.style.right = (100 - maxPct) + '%';
}

// initPriceSliders: update fill for all existing sliders (called after DOM changes)
function initPriceSliders() {
  document.querySelectorAll('.price-slider').forEach(updateSliderFill);
}

// initPriceSliderObservers: watch Dawn's filter containers for AJAX re-renders
// so sliders re-init when the price filter sidebar is replaced
function initPriceSliderObservers() {
  ['FacetsWrapperDesktop', 'FacetsWrapperMobile'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) {
      new MutationObserver(function() {
        initPriceSliders();
      }).observe(el, { childList: true, subtree: true });
    }
  });
}

// Delegated: slider dragging → update fill + text input value (no AJAX yet)
document.addEventListener('input', function(event) {
  var range = event.target.closest('.price-slider__range');
  if (!range) return;
  var slider = range.closest('.price-slider');
  if (!slider) return;
  var minRange = slider.querySelector('.price-slider__range--min');
  var maxRange = slider.querySelector('.price-slider__range--max');
  var minVal = parseFloat(minRange.value);
  var maxVal = parseFloat(maxRange.value);
  // Prevent handles from crossing each other
  if (minVal > maxVal) {
    if (range === minRange) { minRange.value = maxVal; minVal = maxVal; }
    else { maxRange.value = minVal; maxVal = minVal; }
  }
  updateSliderFill(slider);
  // Mirror value into corresponding text input (no change event → no AJAX)
  var isMin = range.classList.contains('price-slider__range--min');
  var inputId = isMin ? slider.dataset.minInput : slider.dataset.maxInput;
  if (inputId) {
    var textInput = document.getElementById(inputId);
    if (textInput) textInput.value = isMin ? minVal : maxVal;
  }
});

// Delegated: slider released → fire change on text input → Dawn AJAX filter
// Delegated: text input changed → sync slider position
document.addEventListener('change', function(event) {
  // Case A: a range slider handle was moved and released
  var range = event.target.closest('.price-slider__range');
  if (range) {
    var slider = range.closest('.price-slider');
    if (!slider) return;
    var minRange = slider.querySelector('.price-slider__range--min');
    var maxRange = slider.querySelector('.price-slider__range--max');
    // Final clamp after release
    if (parseFloat(minRange.value) > parseFloat(maxRange.value)) {
      if (range === minRange) minRange.value = maxRange.value;
      else maxRange.value = minRange.value;
    }
    updateSliderFill(slider);
    // Update text input and trigger Dawn's price-range AJAX
    var isMin = range.classList.contains('price-slider__range--min');
    var inputId = isMin ? slider.dataset.minInput : slider.dataset.maxInput;
    if (inputId) {
      var textInput = document.getElementById(inputId);
      if (textInput) {
        textInput.value = range.value;
        // Dispatch change so Dawn's <price-range> picks it up and filters
        textInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    return;
  }

  // Case B: a price text input was changed by the user (or by Dawn)
  // Sync slider to match the new value
  var textField = event.target.closest('.field__input');
  if (textField) {
    var priceRange = textField.closest('price-range');
    if (!priceRange) return;
    var slider = priceRange.querySelector('.price-slider');
    if (!slider) return;
    var isMin = textField.id && textField.id.indexOf('-GTE') !== -1;
    var rangeInput = slider.querySelector(isMin ? '.price-slider__range--min' : '.price-slider__range--max');
    if (rangeInput) {
      var val = parseFloat(textField.value);
      if (!isNaN(val)) {
        rangeInput.value = val;
        updateSliderFill(slider);
      }
    }
  }
});

function initHeader() {
  const header = document.querySelector('.header');
  const links = document.querySelector('.headerNavbarLinks');
  // Find first visible hero (A/B test may hide variant A via display:none)
  const hero = Array.from(document.querySelectorAll('.hero')).find(h => h.offsetHeight > 0) || document.querySelector('.hero');
  if (!header) return;

  // ResizeObserver обновляет --site-header-height, но ТОЛЬКО вне анимации.
  // Во время transition читать offsetHeight + писать CSS-переменную = layout reflow
  // на каждом кадре → ступенчатая анимация. Флаг isTransitioning блокирует это.
  let isTransitioning = false;
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(function() {
      if (!isTransitioning) syncHeaderHeight();
    }).observe(header);
  }

  let isMobile = window.innerWidth <= 768;
  let menuOpen = false;

  // Кэш состояний
  let state = {
    scrolled: window.scrollY > 50,
    fixed: false,
    linksHidden: false
  };

  // Применяем начальные классы
  if (state.scrolled) header.classList.add('scrolled');
  if (state.fixed) header.classList.add('fixed');

  // Порог скрытия nav-ссылок: когда низ hero уходит за экран.
  // Гистерезис 140px предотвращает мерцание при медленном скролле.
  // scrollY-подход вместо IntersectionObserver — нет feedback loop через layout shift.
  const heroEndY = hero ? (hero.offsetTop + hero.offsetHeight) : 9999;
  const LINKS_HIDE_AT  = Math.max(heroEndY - 80,  100);
  const LINKS_SHOW_AT  = Math.max(heroEndY - 220, 50);

  // Lock: блокируем re-evaluation на 400ms после изменения scrolled/linksHidden.
  // Без него: header shrink → --site-header-height update → layout shift →
  // scrollY jump → порог снова пробивается → бесконечный цикл.
  let scrollLocked = false;
  let scrollLockTimer = null;
  function setScrollLock() {
    scrollLocked = true;
    isTransitioning = true;
    clearTimeout(scrollLockTimer);
    scrollLockTimer = setTimeout(() => {
      scrollLocked = false;
      isTransitioning = false;
      syncHeaderHeight(); // один вызов после завершения transition
    }, 400);
  }

  // === ОБНОВЛЕНИЕ SCROLLED, FIXED И LINKS СОСТОЯНИЙ ===
  function updateScrolledState() {
    if (scrollLocked) return;
    const y = window.scrollY;

    // SCROLLED — визуальные изменения хедера
    const SCROLLED_ON = isMobile ? 100 : 50;
    const SCROLLED_OFF = isMobile ? 60 : 30;
    if (!state.scrolled && y >= SCROLLED_ON) {
      header.classList.add('scrolled');
      state.scrolled = true;
      setScrollLock();
    } else if (state.scrolled && y <= SCROLLED_OFF) {
      header.classList.remove('scrolled');
      state.scrolled = false;
      setScrollLock();
    }

    // FIXED — shadow появляется при глубоком скролле
    const FIXED_ON = isMobile ? 200 : 90;
    const FIXED_OFF = isMobile ? 100 : 20;
    if (!state.fixed && y >= FIXED_ON) {
      header.classList.add('fixed');
      state.fixed = true;
    } else if (state.fixed && y <= FIXED_OFF) {
      header.classList.remove('fixed');
      state.fixed = false;
    }

    // LINKS — скрываем навигацию когда hero уходит за экран
    if (links && !menuOpen) {
      if (!state.linksHidden && y >= LINKS_HIDE_AT) {
        links.classList.add('linksHidden');
        state.linksHidden = true;
        syncHeaderHeight();
      } else if (state.linksHidden && y <= LINKS_SHOW_AT) {
        links.classList.remove('linksHidden');
        state.linksHidden = false;
        syncHeaderHeight();
      }
    }
  }

  // Тонкий debounce для стабильности
  let scrollTimer = null;
  function handleScroll() {
    if (scrollTimer) return;
    scrollTimer = requestAnimationFrame(() => {
      updateScrolledState();
      scrollTimer = null;
    });
  }

  window.addEventListener('resize', () => {
    isMobile = window.innerWidth <= 768;
  }, { passive: true });

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Отслеживаем открытие мобильного меню
  const toggle = document.querySelector('.mobileMenuToggle');
  if (toggle && links) {
    toggle.addEventListener('click', () => {
      menuOpen = links.classList.contains('mobileOpen');
      // При открытии меню показываем навигацию
      if (!menuOpen) {
        links.classList.remove('linksHidden');
        state.linksHidden = false;
      }
    });
  }

  updateScrolledState();
}


function showLinks() {
  const links = document.querySelector('.headerNavbarLinks');
  if (links && links.classList.contains('linksHidden')) {
    links.classList.remove('linksHidden');
  }
}

function hideLinks() {
  const links = document.querySelector('.headerNavbarLinks');
  if (links && !links.classList.contains('mobileOpen')) {
    links.classList.add('linksHidden');
  }
}

function initNavbarPredictiveSearch() {
  var input = document.getElementById('Search-In-Navbar');
  var dropdown = document.getElementById('navbar-search-dropdown');
  var form = document.getElementById('navbar-search-form');
  if (!input || !dropdown || !form) return;

  var debounceTimer = null;
  var currentQuery = '';
  var cache = {};

  function showDropdown(html, query) {
    dropdown.innerHTML = html;

    // Replace "Search for X" with "View all results for X"
    // Note: predictive search API returns max 10 items — not the real catalog count,
    // so we intentionally omit the number to avoid misleading users.
    var searchForEl = dropdown.querySelector('[data-predictive-search-search-for-text]');
    if (searchForEl) {
      searchForEl.textContent = 'View all results for "' + query + '"';
    }

    dropdown.style.display = 'block';
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    dropdown.innerHTML = '';
  }

  function fetchResults(query) {
    if (cache[query]) { showDropdown(cache[query], query); return; }
    var searchTypes = form.dataset.searchTypes || 'product,collection,article,page';
    var searchLimit = form.dataset.searchLimit || '8';
    fetch('/search/suggest?q=' + encodeURIComponent(query) + '&section_id=predictive-search&resources[limit]=' + searchLimit + '&resources[limit_scope]=each&resources[type]=' + searchTypes)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('#shopify-section-predictive-search');
        if (!section) return;
        var markup = section.innerHTML;
        cache[query] = markup;
        if (query === currentQuery) showDropdown(markup, query);
      })
      .catch(function() {});
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    currentQuery = this.value.trim();
    if (!currentQuery) { hideDropdown(); return; }
    debounceTimer = setTimeout(function() { fetchResults(currentQuery); }, 280);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { hideDropdown(); input.blur(); }
  });

  form.addEventListener('submit', function() { hideDropdown(); });

  document.addEventListener('click', function(e) {
    if (!form.contains(e.target)) hideDropdown();
  });
}

function initSearchPlaceholder() {
  const input = document.querySelector('#Search-In-Navbar');
  if (!input) return;

  const words = ['shades', 'brands', 'eyewear'];
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let timeoutId = null;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  function animate() {
    const currentWord = words[wordIndex];
    
    if (!isDeleting && charIndex <= currentWord.length) {
      input.placeholder = 'Search for ' + currentWord.substring(0, charIndex);
      charIndex++;
      timeoutId = setTimeout(animate, 100);
    } else if (!isDeleting && charIndex > currentWord.length) {
      timeoutId = setTimeout(() => {
        isDeleting = true;
        animate();
      }, 2000);
    } else if (isDeleting && charIndex >= 0) {
      input.placeholder = 'Search for ' + currentWord.substring(0, charIndex);
      charIndex--;
      timeoutId = setTimeout(animate, 50);
    } else if (isDeleting && charIndex < 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
      charIndex = 0;
      timeoutId = setTimeout(animate, 100);
    }
  }

  input.addEventListener('focus', () => {
    if (timeoutId) clearTimeout(timeoutId);
  });

  input.addEventListener('blur', () => {
    if (timeoutId) clearTimeout(timeoutId);
    charIndex = 0;
    isDeleting = false;
    animate();
  });

  /* Запускаем анимацию только после первого реального взаимодействия пользователя.
     Боты (sitespeed, Lighthouse) не двигают мышью → placeholder не меняется →
     LastVisualChange остаётся чистым (без ~9s хвоста от typewriter). */
  var _placeholderStarted = false;
  function startPlaceholderOnInteract() {
    if (_placeholderStarted) return;
    _placeholderStarted = true;
    animate();
  }
  ['mousemove', 'touchstart', 'keydown', 'scroll'].forEach(function(ev) {
    window.addEventListener(ev, startPlaceholderOnInteract, { once: true, passive: true });
  });
}

function initLikeButtons() {
  document.querySelectorAll('.bestSellingLikeIcon').forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      this.classList.toggle('liked');
    });
  });
}


function initScrollHandlers() {
  const scrollContainers = document.querySelectorAll('.bestSellingGrid, .brands');
  
  scrollContainers.forEach(container => {
    let isDown = false;
    let startX;
    let scrollLeft;

    container.addEventListener('mousedown', (e) => {
      isDown = true;
      container.classList.add('active');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.classList.remove('active');
    });

    container.addEventListener('mouseup', () => {
      isDown = false;
      container.classList.remove('active');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    });
  });
}

function initChallengePage() {
  if (!window.location.pathname.startsWith('/challenge')) return;

  const mainContent = document.querySelector('#MainContent');
  const newsletterContainer = document.querySelector('.newsletterContainer');
  if (!mainContent || !newsletterContainer) return;

  // Move challenge content into the newsletter section, below the form fields
  const challengeContent = mainContent.firstElementChild;
  if (challengeContent) {
    mainContent.style.display = 'none';
    challengeContent.classList.add('newsletterChallenge');
    const formFields = newsletterContainer.querySelector('.newsletterFormFields');
    if (formFields) {
      formFields.insertAdjacentElement('afterend', challengeContent);
    } else {
      newsletterContainer.appendChild(challengeContent);
    }
    // Scroll to the challenge form
    setTimeout(function() {
      challengeContent.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }
}

function scrollToNewsletterSuccess(el) {
  if (!el) return;
  // setTimeout overrides browser's native anchor scroll (#ContactFooter)
  setTimeout(function() {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 100);
}

function initNewsletter() {
  const formDiv = document.querySelector('.newsletterForm');
  if (!formDiv) return;

  const form = formDiv.closest('form');
  if (!form) return;

  const successMsg = form.querySelector('.newsletterSuccess');
  const fields = form.querySelector('.newsletterFormFields');

  // If Liquid rendered success (form.posted_successfully?) — override browser anchor scroll
  if (successMsg && !successMsg.hidden) {
    scrollToNewsletterSuccess(successMsg);
    return;
  }

  // Inline email validation only — do NOT preventDefault on the form submit
  // so hcaptcha can properly intercept and show its challenge dialog
  form.addEventListener('submit', function(e) {
    const input = form.querySelector('.newsletterInput');
    const error = form.querySelector('.newsletterError');
    if (!input || !input.value.trim()) {
      e.preventDefault();
      if (error) error.style.display = 'block';
    } else {
      if (error) error.style.display = 'none';
    }
  }, { capture: false });
}

function initMobileMenu() {
  const toggle  = document.querySelector('.mobileMenuToggle');
  const links   = document.querySelector('.headerNavbarLinks');
  const drawer  = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mobile-drawer-overlay');

  if (!toggle) return;

  // PERF: lazy-attach drawer — детачим из DOM сразу, реаттачим при первом открытии
  let drawerAttached = false;
  let drawerParent = null, drawerNext = null;
  if (drawer && drawer.parentNode) {
    drawerParent = drawer.parentNode;
    drawerNext   = drawer.nextSibling;
    drawer.parentNode.removeChild(drawer);
  }
  function ensureDrawerAttached() {
    if (drawerAttached || !drawer || !drawerParent) return;
    if (drawerNext && drawerNext.parentNode === drawerParent) {
      drawerParent.insertBefore(drawer, drawerNext);
    } else {
      drawerParent.appendChild(drawer);
    }
    drawerAttached = true;
  }

  // ── Stack-based slide drawer (mobile ≤768px) ──────────────────
  let drawerStack = [];

  function isMobile() { return window.innerWidth <= 768; }

  function openDrawer() {
    if (!drawer) return;
    ensureDrawerAttached(); // PERF: реаттач при первом открытии
    // Set container top = header bottom so menu starts below header
    const header = document.querySelector('.header');
    if (header) {
      const headerBottom = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--mobile-menu-top', headerBottom + 'px');
    }
    drawerStack = ['root'];
    drawer.querySelectorAll('.mobile-panel').forEach(p => {
      p.classList.remove('is-active', 'is-prev');
    });
    const root = drawer.querySelector('[data-panel="root"]');
    if (root) root.classList.add('is-active');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.classList.remove('active');
    document.body.style.overflow = '';
    drawerStack = [];
  }

  function openPanel(targetId) {
    if (!drawer || !drawerStack.length) return;
    const currentId   = drawerStack[drawerStack.length - 1];
    const currentPanel = drawer.querySelector('[data-panel="' + currentId + '"]');
    const targetPanel  = drawer.querySelector('[data-panel="' + targetId + '"]');
    if (!currentPanel || !targetPanel) return;

    currentPanel.classList.remove('is-active');
    currentPanel.classList.add('is-prev');
    targetPanel.classList.remove('is-prev');
    targetPanel.classList.add('is-active');
    drawerStack.push(targetId);
  }

  function goBack() {
    if (!drawer || drawerStack.length <= 1) { closeDrawer(); return; }
    const currentId   = drawerStack.pop();
    const prevId      = drawerStack[drawerStack.length - 1];
    const currentPanel = drawer.querySelector('[data-panel="' + currentId + '"]');
    const prevPanel    = drawer.querySelector('[data-panel="' + prevId + '"]');
    if (!currentPanel || !prevPanel) return;

    currentPanel.classList.remove('is-active');
    prevPanel.classList.remove('is-prev');
    prevPanel.classList.add('is-active');
  }

  // Toggle button
  toggle.addEventListener('click', () => {
    if (isMobile()) {
      drawer && drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    } else if (links) {
      links.classList.toggle('mobileOpen');
      toggle.classList.toggle('active');
    }
  });

  // Overlay closes drawer
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Delegated clicks inside drawer
  if (drawer) {
    drawer.addEventListener('click', function(e) {
      const parentBtn = e.target.closest('.mobile-panel__link--parent');
      if (parentBtn) { const t = parentBtn.dataset.target; if (t) openPanel(t); return; }

      const backBtn = e.target.closest('.mobile-panel__back');
      if (backBtn) { goBack(); return; }

      const closeBtn = e.target.closest('.mobile-drawer__close');
      if (closeBtn) { closeDrawer(); return; }
    });
  }

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });
}

function initMobileDropdown() {
  const dropdownItems = document.querySelectorAll('.nav-item-with-dropdown');
  
  dropdownItems.forEach(item => {
    item.addEventListener('click', function(e) {
      // Только для мобильных устройств
      if (window.innerWidth > 768) return;
      
      e.preventDefault();
      const wrapper = this.closest('.nav-item-wrapper');
      if (wrapper) {
        // Закрываем другие открытые dropdowns
        document.querySelectorAll('.nav-item-wrapper.mobile-open').forEach(w => {
          if (w !== wrapper) {
            w.classList.remove('mobile-open');
          }
        });
        wrapper.classList.toggle('mobile-open');
      }
    });
  });
}

function initFooterAccordion() {
  const footerTitles = document.querySelectorAll('.footerTitle');
  
  footerTitles.forEach(title => {
    title.addEventListener('click', function() {
      if (window.innerWidth <= 768) {
        const list = this.nextElementSibling;
        if (list && list.classList.contains('footerList')) {
          const isOpen = list.style.maxHeight && list.style.maxHeight !== '0px';
          
          // Закрываем все остальные
          document.querySelectorAll('.footerList').forEach(l => {
            l.style.maxHeight = '0';
            l.classList.remove('open');
          });
          document.querySelectorAll('.footerTitle').forEach(t => {
            t.classList.remove('active');
          });
          
          // Открываем текущий
          if (!isOpen) {
            list.style.maxHeight = list.scrollHeight + 'px';
            list.classList.add('open');
            this.classList.add('active');
          }
        }
      }
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      document.querySelectorAll('.footerList').forEach(list => {
        list.style.maxHeight = 'none';
        list.classList.remove('open');
      });
      document.querySelectorAll('.footerTitle').forEach(title => {
        title.classList.remove('active');
      });
    }
  });
}

function initCategoriesSlider() {
  const slider = document.getElementById('categoriesSlider');
  const btnLeft = document.querySelector('.sliderBtnLeft');
  const btnRight = document.querySelector('.sliderBtnRight');

  if (!slider || !btnLeft || !btnRight) return;

  function updateButtons() {
    const atStart = slider.scrollLeft <= 0;
    const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
    btnLeft.disabled = atStart;
    btnRight.disabled = atEnd;
  }

  btnLeft.addEventListener('click', () => {
    slider.scrollBy({ left: -300, behavior: 'smooth' });
    setTimeout(updateButtons, 320);
  });

  btnRight.addEventListener('click', () => {
    slider.scrollBy({ left: 300, behavior: 'smooth' });
    setTimeout(updateButtons, 320);
  });

  slider.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons, { passive: true });

  updateButtons();
}

function goToProduct(collection, productId) {
  window.location.href = `product.html?collection=${collection}&id=${productId}`;
}

// ===== Product page: accordion tabs =====
window.toggleAccordion = function(header) {
  var item = header.closest('.accordionItem');
  if (!item) return;
  // Toggle current item, reset truncated state when closing
  var isOpen = item.classList.contains('accordionOpen');
  item.classList.toggle('accordionOpen');
  if (isOpen) {
    var content = item.querySelector('.accordionContent--truncated');
    if (content) content.classList.remove('expanded');
    var moreBtn = item.querySelector('.accordionMoreBtn');
    if (moreBtn && !content.classList.contains('accordionContent--fits')) moreBtn.style.display = '';
  }
};

window.toggleAccordionMore = function(btn) {
  var item = btn.closest('.accordionItem');
  if (!item) return;
  var content = item.querySelector('.accordionContent--truncated');
  if (!content) return;
  var isExpanded = content.classList.toggle('expanded');
  btn.textContent = isExpanded ? 'Read less' : 'Read more';
};

function checkAccordionMoreVisibility() {
  var PX_LIMIT = parseFloat(getComputedStyle(document.documentElement).fontSize) * 30;
  document.querySelectorAll('.accordionContent--truncated').forEach(function(content) {
    var btn = content.parentElement.querySelector('.accordionMoreBtn');
    if (!btn) return;
    // Reset state before re-checking so images-loaded pass can correct DOMContentLoaded pass
    content.classList.remove('accordionContent--fits');
    btn.style.display = '';
    content.classList.add('expanded');
    var fullHeight = content.scrollHeight;
    content.classList.remove('expanded');
    if (fullHeight <= PX_LIMIT) {
      btn.style.display = 'none';
      content.classList.add('accordionContent--fits');
    }
  });
}
checkAccordionMoreVisibility();
// Re-check after images load so image heights are counted
window.addEventListener('load', checkAccordionMoreVisibility);

function initBottomBar() {
  const bottomBar = document.getElementById('bottomBar');
  if (!bottomBar) return;

  const buttons = document.querySelector('.buttons');
  if (!buttons) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          bottomBar.classList.add('bottomBarVisible');
        } else {
          bottomBar.classList.remove('bottomBarVisible');
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -50px 0px' }
  );

  observer.observe(buttons);
}

// === Voice Search (перенести сюда из HTML) ===
document.addEventListener('DOMContentLoaded', function() {
  const voiceBtn = document.querySelector('.voice-search-btn');
  const searchInput = document.querySelector('.navbarSearchWrapper input');
  
  if (voiceBtn && searchInput) {
    voiceBtn.addEventListener('click', function(e) {
      e.preventDefault();
      startVoiceSearch(searchInput, voiceBtn);
    });
  }
  
  function startVoiceSearch(inputElement, btnElement) {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      
      recognition.lang = 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      
      const originalColor = btnElement.style.color;
      btnElement.style.transform = 'scale(1.1)';
      btnElement.style.color = 'var(--color-red)';
      
      recognition.start();
      
      recognition.onresult = function(event) {
        const transcript = event.results[0][0].transcript;
        inputElement.value = transcript;
      };
      
      recognition.onerror = function(event) {
        console.error('Speech recognition error:', event.error);
        if (event.error === 'not-allowed') {
          alert('Please allow microphone access to use voice search.');
        } else if (event.error === 'network') {
          alert('Network error. Please check your connection.');
        }
      };
      
      recognition.onend = function() {
        btnElement.style.transform = '';
        btnElement.style.color = originalColor || '#ff580d';
      };
      
    } else {
      alert('Voice search is not supported in your browser. Please try Chrome, Edge, or Safari.');
    }
  }
});